import { render } from "./CustomizableCloseButton.vue?vue&type=template&id=54fe6b1b"
import script from "./CustomizableCloseButton.vue?vue&type=script&lang=ts"
export * from "./CustomizableCloseButton.vue?vue&type=script&lang=ts"
script.render = render

export default script